import { createContext } from 'react';
import type { Organization, ProjectInput } from '../types';
import type { OrgDocumentKey } from '../prompts/orgDocuments';

export interface OrgDocumentGenerationResult {
  key: OrgDocumentKey;
  content: string;
  generatedAt: string;
  progress: { done: number; total: number };
}

export interface OrganizationsContextValue {
  organizations: Organization[];
  activeOrganizationId: string | null;
  setActiveOrganizationId: (id: string | null) => void;
  createOrganization: (name: string, input: ProjectInput) => Promise<Organization>;
  updateOrganization: (org: Organization) => Promise<void>;
  deleteOrganization: (id: string) => Promise<void>;
  linkToProject: (orgId: string, projectId: string) => Promise<void>;
  unlinkFromProject: (orgId: string, projectId: string) => Promise<void>;
  refreshOrganizations: () => Promise<void>;
  generateOrgDocument: (orgId: string, key: OrgDocumentKey) => Promise<OrgDocumentGenerationResult>;
  resetOrgDocument: (orgId: string, key: OrgDocumentKey) => void;
  loadingOrganizations: boolean;
}

export const OrganizationsContext = createContext<OrganizationsContextValue | null>(null);
